import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Flex, Input } from '@chakra-ui/react';
import { useEffect, useMemo, useRef, useState } from 'react';
export const Pagination = ({ total, defaultCurrent = 1, defaultPageSize = 10, current: propCurrent, pageSize: propPageSize, onChange, }) => {
    const [current, setCurrent] = useState(defaultCurrent);
    const [pageSize] = useState(propPageSize !== null && propPageSize !== void 0 ? propPageSize : defaultPageSize);
    const inputRef = useRef(null);
    const totalPage = useMemo(() => Math.ceil(total / pageSize), [total, pageSize]);
    useEffect(() => {
        if (totalPage > 1 && current > totalPage) {
            setCurrent(totalPage);
        }
        else if (current !== 1) {
            setCurrent(1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [totalPage]);
    if (totalPage <= 1) {
        return _jsx(_Fragment, {});
    }
    const onJump = (page) => {
        if (inputRef.current && inputRef.current.value !== String(page)) {
            inputRef.current.value = String(page);
        }
        setCurrent(page);
        onChange === null || onChange === void 0 ? void 0 : onChange(page, pageSize);
    };
    const onInputFocus = (e) => {
        e.target.setSelectionRange(0, String(totalPage).length);
    };
    const onInputJump = (e) => {
        const inputNumber = parseInt(e.target.value);
        const adjustedPage = isNaN(inputNumber) ? 1 : Math.min(Math.max(1, inputNumber), totalPage);
        if (adjustedPage !== current) {
            onJump(adjustedPage);
        }
        else if (adjustedPage !== inputNumber) {
            e.target.value = String(inputNumber);
        }
    };
    const onInputKeyDown = (e) => {
        if (e.key === 'Enter') {
            onInputJump(e);
        }
    };
    return (_jsxs(Flex, Object.assign({ align: "center", justify: "right", mt: "3" }, { children: [_jsx(Button, Object.assign({ mr: "4px", onClick: () => onJump(1), isDisabled: current <= 1 }, { children: '<<' })), _jsx(Button, Object.assign({ mr: "4px", onClick: () => onJump(current - 1), isDisabled: current <= 1 }, { children: '<' })), _jsxs(Box, Object.assign({ mr: "8px" }, { children: [_jsx(Input, { ml: "4px", size: "xs", fontSize: "sm", defaultValue: current, style: { width: '50px' }, ref: inputRef, onFocus: onInputFocus, onBlur: onInputJump, onKeyDown: onInputKeyDown }), _jsx("span", Object.assign({ style: { margin: '0 10px' } }, { children: "/" })), totalPage] })), _jsx(Button, Object.assign({ mr: "4px", onClick: () => onJump(current + 1), isDisabled: current >= totalPage }, { children: '>' })), _jsx(Button, Object.assign({ mr: "4px", onClick: () => onJump(totalPage), isDisabled: current >= totalPage }, { children: '>>' }))] })));
};
